import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';

import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';
import { TeamService } from '../../../services/team.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Utilities } from '../../../services/utilities';

import { Roles, TeamType } from '../../../models/enums';
import { OptionsByRole } from '../options-by-role';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css'],
  imports: [
    MatButtonModule,
    CommonModule,
    RouterModule
  ],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class MainMenuComponent implements OnInit {
  @Input() openedSideBar = false;
  @Output() sidebarClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  isUserInTeam: boolean;

  activeValsSelected: boolean = false;
  menu: {
    role: Roles;
    title: string;
    options: { title: string; url: string; inActionMenu: boolean; parameters?: object }[];
  };

  userId = '';

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private teamService: TeamService,
    private alertService: AlertService,
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {
    this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.updateUserData();
        this.authService.getActiveRoleChangeEvent().subscribe(() => {
          if (this.authService.isRestoringUserContextAfterRefresh) return;
          this.updateUserData()
        });
        this.authService.getActiveValuesSelectedChangeEvent().subscribe(() => {
          if (this.authService.isRestoringUserContextAfterRefresh) return;
          this.updateUserData()
        });
      }
    });
  }

  updateUserData() {
    const activeRole = this.accountService.GetActiveRole();
    this.userId = this.accountService.GetCurrentLoggedUserId();
    this.activeValsSelected = this.accountService.GetActiveValsSelected();
    if (this.activeValsSelected) {
      this.menu = OptionsByRole.find(opt => opt.role === activeRole);
    } else {
      this.menu = null;
    }
    /*this.menu = OptionsByRole.find(opt => opt.role === activeRole);*/

    if (activeRole === Roles.QCCoder || activeRole === Roles.QCSupervisor) {
      this.isCurrentUserInTeam(this.teamService.getTeamTypeFromRole(activeRole));
    }
  }

  closeSidebar(): void {
    this.sidebarClicked.emit(true);
  }

  logout() {
    this.closeSidebar();
    this.authService.logout();
    this.authService.redirectLogoutUser();
  }

  isCurrentUserInTeam(teamType?: TeamType) {
    this.teamService.isUserInTeam(teamType)
      .subscribe({ next: userTeamResult => this.isUserInTeam = userTeamResult,
        error: (error) => {
          this.alertService.showStickyMessage('Load Error',
            `Unable to retrieve user team information from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }});
  }

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: MouseEvent): void {
    if (!this.openedSideBar) {
      return;
    }

    const sideMenuClicked = this.elementRef.nativeElement.contains(event.target);
    const menuButtonClicked = this.elementRef.nativeElement.parentElement.querySelector('#menuBtn').contains(event.target);

    if (!sideMenuClicked && !menuButtonClicked) {
      this.closeSidebar();
    }
  }
}
